import React from 'react';
import { IUnit, PaymentMethod, PaymentPeriod } from '@/types';
import UICollapsibleSection from '@/components/shared/UICollapsibleSection';
import './Rent.scss';

interface RentProps {
  unit: IUnit | null;
  collapsed: boolean;
  onToggleCollapse: () => void;
}

const baseClass = 'Rent';

const Rent: React.FC<RentProps> = ({ unit, collapsed, onToggleCollapse }) => {
  return (
    <UICollapsibleSection
      title="Rent"
      collapsed={collapsed}
      onToggleCollapse={onToggleCollapse}
      className={`${baseClass} mb-24`}
    >
      <div className={`${baseClass}--container`}>
        <div className={`${baseClass}--price`}>
          <div className={`${baseClass}--price-label`}>
            <i className="fa-solid fa-circle-dollar-to-slot"></i>
            <span>The rent</span>
          </div>
          <div className={`${baseClass}--price-value`}>
            <span className={`${baseClass}--tag`}>
              $ {unit?.rentPrice && unit?.rentPrice.toFixed(2)}
            </span>
            <span>
              per{' '}
              {unit?.rentPricePeriod === PaymentPeriod.MONTH ? 'month' : 'week'}
            </span>
          </div>
          <div className={`${baseClass}--price-label`}>
            <i className="fa-solid fa-circle-dollar-to-slot"></i>
            <span>The total cost of services</span>
          </div>
          <div className={`${baseClass}--price-value`}>
            <span className={`${baseClass}--tag`}>
              $ {unit?.costOfServices && unit?.costOfServices.toFixed(2)}
            </span>
          </div>
          <div className={`${baseClass}--price-label`}>
            <i className="fa-solid fa-file-invoice-dollar"></i>
            <span>The total rent</span>
          </div>
          <div className={`${baseClass}--price-value`}>
            <span className={`${baseClass}--tag`}>
              $ {unit?.totalRentPrice && unit?.totalRentPrice.toFixed(2)}
            </span>
          </div>
        </div>

        <div className={`${baseClass}--terms`}>
          <div className={`${baseClass}--terms-title`}>
            <i className="fa-solid fa-money-check-dollar"></i>
            <span>Method of payment</span>
          </div>
          <div className={`${baseClass}--terms-value`}>
            <span>
              {unit?.paymentMethod === PaymentMethod.CASH && 'Cash'}
              {unit?.paymentMethod === PaymentMethod.CHEQUE && 'Cheque'}
              {unit?.paymentMethod === PaymentMethod.ELECTRONIC_TRANSFER &&
                'Electronic transfer'}
              {unit?.paymentMethod === PaymentMethod.OTHER && 'Other'}
            </span>
          </div>
        </div>
      </div>
    </UICollapsibleSection>
  );
};

export default Rent;
